const HeroSection = () => {
  const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL;
  return (
    <section>
      <div className="card text-white border-0 hero-card ">
        {/* Responsive image wrapper with fixed height */}
        <div className="card-img-wrapper">
          <img src={`${awsImageBaseUrl}images/other/specialty_FeaturedCaseStudy_banner_v2.png`} className="card-img rounded-0" alt="Hero Background" />
        </div>
        {/* Overlay Content */}
        <div className="card-img-overlay mt-5 text-center hero-overlay pt-5">
          <h1 className="font-bold text-5xl text-black mb-4">
            Specialty
          </h1>
        </div>

      </div>
    </section>
  );
};

export default HeroSection;
